class WordBar extends HTMLElement {
    constructor() {
        super();
        this.wordBarEl = document.querySelector('word-bar');
        
        this.wordBarEl.querySelectorAll('.word-bar__content > li > a').forEach(x=> {
            const el = document.querySelector(`#${x.innerText}1`);
            if (el) {
                const top = el.getBoundingClientRect().y + window.scrollY;
                x.classList.add('enabled');
                x.addEventListener('click', (e) => {
                    e.stopPropagation();
                    window.scrollTo({ top: top - this.wordBarEl.clientHeight - 120 , behavior: 'smooth' })
                })
            }
        });
        this.container = this.wordBarEl.querySelector('.word-bar__container');
        window.addEventListener('scroll', () => {
            if (window.screenY < this.wordBarEl.getBoundingClientRect().y) {
                this.container.classList.remove('word-bar__container__fixed');
            } else {
                this.container.classList.add('word-bar__container__fixed');
            }
        });
    }
}
  
customElements.define('word-bar', WordBar);
  